import { _ as _define_property } from "@swc/helpers/_/_define_property";
var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: [
            _vm.$style.container,
            _setup.isApp ? _vm.$style.inApp : ''
        ]
    }, [
        _c('img', {
            class: _vm.$style.logo,
            attrs: {
                "src": require("@/assets/img/logo.png"),
                "alt": ""
            }
        }),
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('h3', {
                class: _vm.$style.title
            }, [
                _vm._v(" Instrucciones para eliminar una cuenta de Órale-Crédito flexible ")
            ]),
            _c('h4', {
                class: _vm.$style.subTitle
            }, [
                _vm._v(" Developer:Centinela Capital "),
                _c('br'),
                _vm._v(" Compañía:CENTINELA CAPITAL S.A. DE C.V. ")
            ]),
            _c('p', {
                class: _vm.$style.inputTitle
            }, [
                _vm._v(" Por favor, introduzca el número de la cuenta que desea eliminar: ")
            ]),
            _c('van-form', {
                on: {
                    "submit": _setup.onSubmit
                }
            }, [
                _c('div', {
                    class: _vm.$style.inputWrapper
                }, [
                    _c('van-field', {
                        attrs: {
                            "type": "digit",
                            "name": "phone",
                            "placeholder": _setup.inputFocus.phoneInput ? '' : 'Número de teléfono (10 digitos)',
                            "maxlength": 10,
                            "border": false,
                            "label-class": _vm.$style.label
                        },
                        on: {
                            "input": _setup.onChangePhoneNumber,
                            "focus": function($event) {
                                _setup.inputFocus.phoneInput = true;
                            },
                            "blur": function($event) {
                                _setup.inputFocus.phoneInput = false;
                            }
                        },
                        model: {
                            value: _setup.form.phone,
                            callback: function callback($$v) {
                                _vm.$set(_setup.form, "phone", $$v);
                            },
                            expression: "form.phone"
                        }
                    }),
                    _setup.inputFocus.phoneInput || _setup.form.phone ? _c('p', {
                        class: _vm.$style.placeholder
                    }, [
                        _vm._v(" Introduzca su teléfono ")
                    ]) : _vm._e()
                ], 1),
                _c('div', {
                    class: [
                        _vm.$style.inputWrapper,
                        _vm.$style.captchWrapper
                    ]
                }, [
                    _c('van-field', {
                        attrs: {
                            "type": "digit",
                            "name": "captcha",
                            "placeholder": _setup.inputFocus.captchaInput ? '' : 'Código de verificación',
                            "maxlength": 4,
                            "border": false
                        },
                        on: {
                            "input": _setup.onChangeCaptchaNumber,
                            "focus": function($event) {
                                _setup.inputFocus.captchaInput = true;
                            },
                            "blur": function($event) {
                                _setup.inputFocus.captchaInput = false;
                            }
                        },
                        model: {
                            value: _setup.form.captcha,
                            callback: function callback($$v) {
                                _vm.$set(_setup.form, "captcha", $$v);
                            },
                            expression: "form.captcha"
                        }
                    }),
                    _setup.sendCaptchaStatus === _setup.SendCaptchaStatus.SENDING ? _c('p', {
                        class: _vm.$style.sendBtn
                    }, [
                        _vm._v(" Enviando... ")
                    ]) : _setup.sendCaptchaStatus === _setup.SendCaptchaStatus.COUNTING ? _c('van-count-down', {
                        ref: "countdown",
                        class: _vm.$style.countdown,
                        attrs: {
                            "time": 60 * 1000,
                            "auto-start": false
                        },
                        on: {
                            "finish": _setup.onCountdownFinish
                        },
                        scopedSlots: _vm._u([
                            {
                                key: "default",
                                fn: function fn(timeData) {
                                    return [
                                        _c('span', [
                                            _vm._v(_vm._s(timeData.seconds + 1) + "s")
                                        ])
                                    ];
                                }
                            }
                        ])
                    }) : _setup.sendCaptchaStatus === _setup.SendCaptchaStatus.COUNT_END ? _c('button', {
                        class: _vm.$style.sendBtn,
                        attrs: {
                            "type": "button"
                        },
                        on: {
                            "click": _setup.send
                        }
                    }, [
                        _vm._v(" Reenviar ")
                    ]) : _c('button', {
                        class: _vm.$style.sendBtn,
                        attrs: {
                            "type": "button"
                        },
                        on: {
                            "click": _setup.send
                        }
                    }, [
                        _vm._v("Enviar")
                    ]),
                    _setup.inputFocus.captchaInput || _setup.form.captcha ? _c('p', {
                        class: _vm.$style.placeholder
                    }, [
                        _vm._v(" Código de verificación ")
                    ]) : _vm._e()
                ], 1),
                _c('van-button', {
                    class: [
                        _vm.$style.confirmBtn,
                        _define_property({}, _vm.$style.disabledBtn, !_setup.form.phone || !_setup.form.captcha)
                    ],
                    attrs: {
                        "color": "#222222",
                        "block": ""
                    }
                }, [
                    _c('span', [
                        _vm._v("Confirmar eliminación")
                    ])
                ])
            ], 1),
            _c('section', [
                _c('p', {
                    class: _vm.$style.step
                }, [
                    _vm._v("Solo necesitas tres pasos para eliminar una cuenta:")
                ]),
                _c('p', {
                    class: _vm.$style.step
                }, [
                    _vm._v("Paso 1:Introduce tu número de teléfono móvil registrado")
                ]),
                _c('p', {
                    class: _vm.$style.step
                }, [
                    _vm._v(" Paso 2:Haga clic en\"Enviar\"para obtener el código de verificación para eliminar una cuenta ")
                ]),
                _c('p', {
                    class: _vm.$style.step
                }, [
                    _vm._v(" Paso 3:Haz clic en \"Confirmar eliminación\" para completar la eliminación de la cuenta ")
                ])
            ]),
            _c('section', [
                _c('p', {
                    class: _vm.$style.step
                }, [
                    _vm._v("Instrucciones para eliminar una cuenta:")
                ]),
                _c('img', {
                    class: _vm.$style.guide,
                    attrs: {
                        "src": require("@/assets/img/close-account-guide.png"),
                        "alt": "",
                        "srcset": ""
                    }
                }),
                _c('p', {
                    class: _vm.$style.step
                }, [
                    _vm._v(" Tras eliminar una cuenta, ya no conservaremos su información personal y se borrarán todos los datos de su cuenta. Si desea seguir utilizando nuestros productos, deberá volver a registrarse. ")
                ])
            ])
        ], 1)
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
